var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#2E3190"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9992 18.0264C20.1992 18.0264 14.4242 20.6454 10.4492 25.9364C18.3992 36.492 33.5992 36.492 41.5492 25.9364C37.5742 20.6454 31.7742 18.0264 25.9992 18.0264ZM25.9992 31.9417C22.8742 31.9417 20.3242 29.2698 20.3242 25.9364C20.3242 22.6295 22.8492 19.9311 25.9992 19.9311C29.1492 19.9311 31.6742 22.6295 31.6742 25.9364C31.6742 29.2433 29.1242 31.9417 25.9992 31.9417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.15 25.0635C27.275 25.0635 26.55 24.3228 26.55 23.3704C26.55 22.8677 26.75 22.4445 27.075 22.127C26.725 22.0476 26.375 21.9683 26 21.9683C23.925 21.9683 22.25 23.7407 22.25 25.9365C22.25 28.1323 23.925 29.9048 26 29.9048C28.075 29.9048 29.75 28.1323 29.75 25.9365C29.75 25.381 29.65 24.8519 29.45 24.3757C29.15 24.7989 28.675 25.0635 28.15 25.0635Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_937"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    fill: "white",
    transform: "translate(10 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurVision);
export default __webpack_public_path__ + "static/media/ourVision.f7ef6f8f3c9798db685c097473ac2073.svg";
export { ForwardRef as ReactComponent };